export default __webpack_public_path__ + "static/media/icon-pancakeswap-button.202d23d6.png";